module.exports = __webpack_public_path__ + "img/CAPA.5a1eb68b.jpg";